import { Footer } from '@/components/branding/Footer';
import { useMensalidades } from '@/context/MensalidadesContext';
import { formatDateTime } from '@/lib/dates';

export function AppFooter() {
  const { state } = useMensalidades();
  const label = state.lastUpdated ? formatDateTime(state.lastUpdated) : null;
  return <Footer lastUpdatedLabel={label} loading={state.status === 'loading'} />;
}
